import { render, staticRenderFns } from "./MyBarrels.vue?vue&type=template&id=41aba13c&"
import script from "./MyBarrels.vue?vue&type=script&lang=js&"
export * from "./MyBarrels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports